// extracted by mini-css-extract-plugin
export default {"container":"PollAttachmentList_container__DNjh0"};